// 声明全局变量，确保组件在window对象上可访问
window.TestimonialCarousel = class extends HTMLElement {
  constructor() {
    super();
    this._refs = new Map();
    this._currentIndex = 0;
    this._autoRotateInterval = null;
    this._itemCount = 0;
    this._itemWidth = 0;
    this._itemsPerView = 1;
  }

  connectedCallback() {
    // 初始化引用
    this._refs.set('items', Array.from(this.querySelectorAll('[data-carousel-item]')));
    
    // 尝试在父容器中查找导航按钮
    const parent = this.closest('.testimonial-carousel-wrapper');
    this._refs.set('prev', parent?.querySelector('[data-carousel-prev]') || this.querySelector('[data-carousel-prev]'));
    this._refs.set('next', parent?.querySelector('[data-carousel-next]') || this.querySelector('[data-carousel-next]'));
    
    this._itemCount = this._refs.get('items').length;
    
    // 设置事件监听
    const prevButton = this._refs.get('prev');
    const nextButton = this._refs.get('next');
    
    if (prevButton) {
      prevButton.addEventListener('click', this.scrollToPrevious.bind(this));
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', this.scrollToNext.bind(this));
    }
    
    // 更新布局
    this.updateLayout();
    
    // 启动自动轮播
    this.startAutoRotate();
    
    // 暂停自动轮播在悬停时
    this.addEventListener('mouseenter', this.stopAutoRotate.bind(this));
    this.addEventListener('mouseleave', this.startAutoRotate.bind(this));
    
    // 滚动事件监听器，更新导航按钮状态
    this.addEventListener('scroll', this.updateNavigationButtons.bind(this));
    
    // 响应式布局监听
    window.addEventListener('resize', this.updateLayout.bind(this));
  }

  disconnectedCallback() {
    // 清理资源
    this.stopAutoRotate();
    
    const prevButton = this._refs.get('prev');
    const nextButton = this._refs.get('next');
    
    if (prevButton) {
      prevButton.removeEventListener('click', this.scrollToPrevious.bind(this));
    }
    
    if (nextButton) {
      nextButton.removeEventListener('click', this.scrollToNext.bind(this));
    }
    
    this.removeEventListener('mouseenter', this.stopAutoRotate.bind(this));
    this.removeEventListener('mouseleave', this.startAutoRotate.bind(this));
    this.removeEventListener('scroll', this.updateNavigationButtons.bind(this));
    window.removeEventListener('resize', this.updateLayout.bind(this));
    
    this._refs.clear();
  }

  updateLayout() {
    const items = this._refs.get('items');
    if (!items || items.length === 0) return;
    
    // 计算每个项目的宽度（包括边距）
    const containerWidth = this.clientWidth;
    const firstItem = items[0];
    
    if (firstItem) {
      const computedStyle = window.getComputedStyle(firstItem);
      this._itemWidth = firstItem.offsetWidth + 
                       parseFloat(computedStyle.marginLeft) + 
                       parseFloat(computedStyle.marginRight);
      
      // 计算视口内能显示的项目数量
      this._itemsPerView = Math.max(1, Math.floor(containerWidth / this._itemWidth));
    }
    
    // 更新导航按钮状态
    this.updateNavigationButtons();
  }

  scrollToPrevious() {
    if (this._currentIndex > 0) {
      this._currentIndex--;
      this.scrollToCurrent();
    }
  }

  scrollToNext() {
    if (this._currentIndex < this._itemCount - this._itemsPerView) {
      this._currentIndex++;
      this.scrollToCurrent();
    }
  }

  scrollToCurrent() {
    // 平滑滚动到当前索引位置
    const scrollPosition = this._currentIndex * this._itemWidth;
    this.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }

  updateNavigationButtons() {
    const prevButton = this._refs.get('prev');
    const nextButton = this._refs.get('next');
    
    // 检查是否在开始位置
    const atStart = this.scrollLeft <= 10; // 小阈值以提高精度
    // 检查是否在结束位置
    const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 10;
    
    // 更新按钮状态
    if (prevButton) {
      prevButton.style.opacity = atStart ? '0.5' : '1';
      prevButton.style.pointerEvents = atStart ? 'none' : 'auto';
    }
    if (nextButton) {
      nextButton.style.opacity = atEnd ? '0.5' : '1';
      nextButton.style.pointerEvents = atEnd ? 'none' : 'auto';
    }
  }

  startAutoRotate() {
    this.stopAutoRotate(); // 先停止可能存在的旧定时器
    this._autoRotateInterval = setInterval(() => {
      // 检查是否在结束位置
      const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 10;
      
      if (atEnd) {
        // 返回开始位置
        this.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
        this._currentIndex = 0;
      } else {
        this.scrollToNext();
      }
    }, 2700); // 每5秒自动切换
  }

  stopAutoRotate() {
    if (this._autoRotateInterval) {
      clearInterval(this._autoRotateInterval);
      this._autoRotateInterval = null;
    }
  }

  restartAutoRotate() {
    this.stopAutoRotate();
    this.startAutoRotate();
  }
}

// 使用延迟执行确保DOM已加载完成
document.addEventListener('DOMContentLoaded', function() {
  // 注册自定义元素
  if (!window.customElements.get('testimonial-carousel')) {
    window.customElements.define('testimonial-carousel', window.TestimonialCarousel);
  }
});

// 组件已注册为全局变量，无需导出